import React from 'react';
import PropTypes from 'prop-types';
import BaseStatus from './BaseStatus';
import './BudgetStatus.css';

export default function BudgetStatus(props) {
  return (
    <div className="budget-status">
      <BaseStatus
        labels={[
          {
            id: 'approved',
            label: 'approved',
          },
          {
            id: 'rejected',
            label: 'rejected',
          },
          {
            id: 'waiting',
            label: 'waiting',
          },
        ]}
        status={props.status}
      />
    </div>
  );
}

BudgetStatus.propTypes = {
  status: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/shared/text/BudgetStatus.js